import type { OnboardingFieldConflict } from './types';

export const ROGER_DUPLICATE_SSN_MESSAGE =
  'A patient with this SSN already exists. Update the SSN or select the existing patient before onboarding.';

export const ROGER_GENERIC_ONBOARDING_MESSAGE =
  'Unable to onboard patient in Roger. Please try again.';

interface RogerOnboardingErrorResult {
  message: string;
  fieldConflict?: OnboardingFieldConflict;
}

interface RogerOnboardingResult {
  response?: {
    success?: boolean;
    message?: string;
  };
  fieldConflict?: OnboardingFieldConflict;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function parseRogerOnboardingError(
  error: unknown
): RogerOnboardingErrorResult {
  if (!isRecord(error)) {
    return { message: ROGER_GENERIC_ONBOARDING_MESSAGE };
  }

  const response = error.response;
  if (!isRecord(response) || response.status !== 409) {
    return { message: ROGER_GENERIC_ONBOARDING_MESSAGE };
  }

  const data = response.data;
  if (!isRecord(data)) {
    return { message: ROGER_GENERIC_ONBOARDING_MESSAGE };
  }

  const detail = data.detail;
  if (
    !isRecord(detail) ||
    detail.code !== 'duplicate_patient_ssn' ||
    detail.field !== 'patient_ssn' ||
    detail.tab !== 'extraction'
  ) {
    return { message: ROGER_GENERIC_ONBOARDING_MESSAGE };
  }

  return {
    message: ROGER_DUPLICATE_SSN_MESSAGE,
    fieldConflict: {
      code: 'duplicate_patient_ssn',
      field: 'patient_ssn',
      tab: 'extraction',
      message: ROGER_DUPLICATE_SSN_MESSAGE,
    },
  };
}

export function shouldSuppressRogerOnboardingPushError(
  result: RogerOnboardingResult | null | undefined
): boolean {
  return (
    result?.response?.success === false &&
    result.fieldConflict?.code === 'duplicate_patient_ssn' &&
    result.fieldConflict.field === 'patient_ssn' &&
    result.fieldConflict.tab === 'extraction'
  );
}
